import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { getSimpleRandomInt } from '@/utils/Helpers';

const useStyles = makeStyles({
  new: {
    borderColor: '#EE322A',
  },

  new_btn: {
    'background-color': '#40C646',
  },

  process: {
    borderColor: '#E0832B',
  },

  process_btn: {
    'background-color': '#E1842C',
  },

  success: {
    borderColor: '#007D23',
  },

  success_btn: {
    background: 'linear-gradient(240.52deg, #31D437 12.01%, #0056D8 82.78%)',
  },

  overfill: {
    borderColor: '#007DD8',
  },

  overfill_btn: {
    background: 'linear-gradient(240.52deg, #D33730 12.01%, #0056D8 82.78%)',
  },

  show: {
    borderColor: '#007DD8',
  },

  show_btn: {
    background:
      'linear-gradient(0deg, #EFF2FE, #EFF2FE), linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    color: '#2454FD !important',
  },

  check: {
    borderColor: '#007DD8',
  },

  check_btn: {
    background: '#2454FD',
  },

  action: {
    width: '100%',
    border: 'none',
    'font-weight': '700',
    'font-family': 'inherit',
    color: '#ffffff',
    'border-radius': '5px',
    'line-height': '1.3',
    padding: '11px 15px',
    boxShadow: 'none !important',
  },
});

const randomWord = ['HIT_1', 'HIT_2', 'HIT_3', 'HIT_4'];

const getId = stat => {
  switch (stat) {
    case 'process':
      return 'CONTINUE';

    case 'overfill':
    case 'success':
      return randomWord[getSimpleRandomInt(0, randomWord.length - 1)];

    case 'show':
      return 'SHOW_SOLUTION';

    case 'check':
      return 'MARK_COMPLETE';

    default:
      return 'COMPLETE';
  }
};

/**
 * Beautiful styles for button by selected status
 * Internationalize text id's - 'COMPLETE', 'CONTINUE', some hits for succes - HIT_1 .. HIT_4
 *
 * @param {string} status - one of 'new', 'process', 'success', 'overfill'
 * @param {function(event)} onClick - button click event
 * @returns React.Component - styled button for selected status
 */

function StatusButton({ status, onClick }) {
  const classes = useStyles();

  return (
    <button
      onClick={onClick}
      type="button"
      className={`${classes[`${status}_btn`]} ${classes.action}`}
    >
      <FormattedMessage id={getId(status)} defaultMessage="" />
    </button>
  );
}

StatusButton.propTypes = {
  status: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default StatusButton;
